var _rect, _g, _g2, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemplateNoPageTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    y: 10.2,
    width: 170.01,
    height: 119.8,
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website_Menu",
    "data-name": "Website Menu"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 10.2,
    width: 170.01,
    height: 8.5,
    fill: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.4,
    y: 13.6,
    width: 17,
    height: 1.7,
    rx: 0.85,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.8,
    y: 13.6,
    width: 17,
    height: 1.7,
    rx: 0.85,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.2,
    y: 13.6,
    width: 17,
    height: 1.7,
    rx: 0.85,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.6,
    y: 13.6,
    width: 17,
    height: 1.7,
    rx: 0.85,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.51,
    y: 13.6,
    width: 17,
    height: 1.7,
    rx: 0.85,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.91,
    y: 13.6,
    width: 1.7,
    height: 1.7,
    rx: 0.85,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Browser_Menu",
    "data-name": "Browser Menu"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170.01,
    height: 10.2,
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1,2.55a.85.85,0,1,1-.85-.85A.85.85,0,0,1,5.1,2.55Z",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,2.55a.85.85,0,1,1-.85-.85A.85.85,0,0,1,8.5,2.55Z",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9,2.55a.85.85,0,1,1-.85-.85A.85.85,0,0,1,11.9,2.55Z",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.4,
    y: 5.1,
    width: 119.01,
    height: 3.4,
    rx: 1.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.81,
    y: 5.1,
    width: 40.8,
    height: 3.4,
    rx: 1.7,
    fill: "#fff"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.68,
    y: 23.45,
    width: 161.09,
    height: 99.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166,123.2H4.46v-100H166ZM4.89,122.71H165.55v-99H4.89Z",
    fill: "#4b55f6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateNoPageTitle);
export default __webpack_public_path__ + "static/media/Template_no-page-title.2d201e22260acb5fb16766cf22063965.svg";
export { ForwardRef as ReactComponent };